module.exports = __webpack_public_path__ + "img/plans-acces-ludihealth.d02509d5.jpg";